import { stdObject } from "../../../../data/types/stdObject";

export const openReturnModal = (params: stdObject) => {
  const { setMsg, setWindowValues, branch } = params;
  setMsg("returnModal");
  setWindowValues({
    customer: "",
    doc: "PRE",
    branch,
    code: "",
    loading: false,
  });
};
